import { z } from "zod";
import { customErrorMap, myPreProcess } from "../shared/validation/zod";

z.setErrorMap(customErrorMap);

export const DocumentStructureShowSchema = z.object({

    // required
    id: z.number(),
    business_id: z.number(),
    document_settings_id: z.number(),
    field_id: z.number(),
    show_form: z.preprocess((val) => myPreProcess(val, !!val), z.boolean()),

    created_at: z.string(),
    updated_at: z.string(),
});

export const DocumentStructureShowAddSchema = z.object({

    // optional in create
    id: z.number().optional(),
    business_id: z.number().optional(),

    created_at: z.string().optional(),
    updated_at: z.string().optional(),

    // required
    document_settings_id: z.number(),
    field_id: z.number(),

    // required fields
    show_form: z.preprocess((val) => myPreProcess(val, !!val), z.boolean()),

});

export type DocumentStructureShow = z.infer<typeof DocumentStructureShowSchema>
